import React, { useState, useEffect, useReducer, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import moment from "moment"
import "./index.css"
import _ from 'lodash'

import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip'
import { Sidebar } from 'primereact/sidebar'
import { ConfirmDialog } from 'primereact/confirmdialog'

import { Table } from "../../helpers";
import Menu from '../../helpers/Menu'
import {Button} from '../../helpers'

import Loading from "../../common/Loading"
import ButtonGroup from '../../common/ButtonGroup'
import CopyToClipboard from '../../common/CopyToClipboard'

import { addMaterialMasterTempData, updatedMaterialMasterTemp } from '../../services/api/materialMasterTemp';
import { addMaterialMasterInterimData } from '../../services/api/materialMasterInterim';
import { getMaterialItem, updateMaterialMasterByMaterialId, getMaterialItemByMaterialId } from '../../services/api/materialMaster';
import { getMaterialProductsByCategoryId } from '../../services/api/materialSpecifications';
import { getMaterialProductsUOMsByCategoryId } from '../../services/api/materialProductsUOMs'
import { getMaterialIdTeamData } from '../../services/api/materialIdTeam'
import { getVMIContractsItemsByMaterialId, getVMIContractsItemsByPermMaterialId } from '../../services/api/vmiContractItems'

import MaterialItemRequest from './components/materialItemRequest';
import PendingMaterialItems from './components/pendingMaterialItems';
import EditMaterialItem from './components/editMaterialItem';
import MaterialPendingRequestSearchBar from './components/PendingMaterialItemsSearchBar';
import Search from './components/Search';

import { getFullName, isMobile, sortArrayOfObjectsInAlphabeticalOrder, sortArrayOfObjectsInAscendingDateOrder } from '../../utils'
import { materialItemInitialState } from '../../validation/requestMaterialItemValidation';

import {
    fetchMaterialCategories,
    fetchMaterialBrands,
    fetchMaterialUoms,
    fetchMaterialSpecificationMandatoryTypes,
    fetchMaterialIdTypes,
    fetchStatus,
    fetchOpsEditableMaterials,
    fetchApprovals
} from '../../services/redux/reducers/commonThunk';

import {
    fetchMaterialMasterListData,
    updateMaterialItemData,
    updateMaterialProductsByCaterogy,
    updateMaterialProductsUOMsByCaterogy,
    setIsSearchVisible,
    updateSearchParams
} from '../../services/redux/reducers/materialMaster/materialMaster';

import {
    fetchMaterialProductRequestData,
    approvedMaterialItem
} from '../../services/redux/reducers/materialMaster/materialMasterTemp';

import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { getApprovalInstances } from '../../services/api/approvalInstances';
import Description from '../../common/Description'
import { getPMCompanyConfig } from '../../setup/pmCompanyConfig'
import { DATE_FORMAT } from '../../constants'
import { useSearchPin } from '../../hooks/useSearchPin'


const MaterialMaster = () => {
    const dispatch = useDispatch()
    const { isSearchPinned, toggleSearchPin, setSearchPin } = useSearchPin()
    const jwtToken = Cookies.get('jwtTokenClient')

    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [materialItemTempObj, setMaterialItemTempObj] = useState(materialItemInitialState)
    const [materialItemInterimObj, setMaterialItemInterimObj] = useState(materialItemInitialState)
    const [materialMasterInterimData, setMaterialMasterInterimData] = useState([])
    const [visibleMaterialItemRequest, setVisibleMaterialItemRequest] = useState(false)
    const [visiblePendingMaterialItems, setVisiblePendingMaterialItems] = useState(false)
    const [materialVariantProducts, setMaterialVariantProducts] = useState([])
    const [materialSpecification, setMaterialSpecification] = useState([])
    const [materialSpecificationAttributes, setMaterialSpecificationAttributes] = useState([])
    const [materialItemObj, setMaterialItemObj] = useState(null)
    const [isFilterShown, setIsFilterShown] = useState(true)
    const [isCategoryUser, setIsCategoryUser] = useState(false)
    const [visibleEditPendingMaterialItem, setVisibleEditPendingMaterialItem] = useState(false)
    const [visibleEditMaterialItem, setVisibleEditMaterialItem] = useState(false)
    const [materialImages, setMaterialImages] = useState([])
    const [materialMasterTempSearchInputs, setMaterialMasterTempSearchInputs] = useState({
        searchBy: "all",
        searchText: ""
    })
    const [editedMaterialItemObj, setEditedMaterialItemObj] = useState({})
    const [materialIdTeam, setMaterialIdTeam] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])
    const [vmiContractItems, setVMIContractItems] = useState([])
    const [isConfirmUpdateMaterialDialogVisible, setIsConfirmUpdateMaterialDialogVisible] = useState(false)
    const [confirmUpdateMaterialItemObj, setConfirmUpdateMaterialItemObj] = useState({})
    const [isHoveringSearchZone, setIsHoveringSearchZone] = useState(false)
    const [hasEverHoveredRightEdge, setHasEverHoveredRightEdge] = useState(false)

    const userDetails = useSelector((state) => state.userDetails)
    const userId = useSelector((state) => state.userDetails.userId)
    const rolesList = useSelector((state) => state.userDetails.rolesList)
    const activeRoleId = useSelector((state) => state.userDetails.activeRoleId)
    const materialCategory = useSelector((state) => state.common.materialCategories)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const materialUOMData = useSelector(state => state.common.materialUOMs)
    const materialSpecificationMandatoryTypes = useSelector(state => state.common.materialSpecificationMandatoryTypes)

    const materialIdTypes = useSelector(state => state.common.materialIdTypes)
    const materialProductsByCaterogy = useSelector(state => state.materialMaster.materialProductsByCaterogy)
    const materialProductsUOMsByCaterogy = useSelector(state => state.materialMaster.materialProductsUOMsByCaterogy)
    const statusList = useSelector((state) => state.common.status)
    const paginationParams = useSelector(state => state.materialMaster.paginationParams)
    const materialMasterListPaginationParams = useSelector(state => state.materialMaster.materialMasterListPaginationParams)
    const materialMasterSearchParams = useSelector(state => state.materialMaster.searchParams)
    const materialMasterListData = useSelector(state => state.materialMaster.materialMasterListData)
    const isPageLoading = useSelector(state => state.materialMaster.loading)
    const pmCompanyUsers = useSelector((state) => state.userDetails.PMCompanyDetails.companyUsers)
    const isSearchVisible = useSelector(state => state.materialMaster.isSearchVisible)
    const isSearchActive = useSelector(state => state.materialMaster.isSearchActive)
    const approvals = useSelector(state => state.common.approvals)

    const searchParams = useSelector(state => state.materialMaster.searchParams)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const actionMenu = useRef(null)

    const isMobileDevice = isMobile()
    
    useEffect(() => {
        if (jwtToken) {
            dispatch(fetchMaterialCategories())
            dispatch(fetchMaterialBrands())
            dispatch(fetchMaterialUoms())
            dispatch(fetchMaterialSpecificationMandatoryTypes())
            // dispatch(fetchMaterialIdTeam())
            dispatch(fetchMaterialIdTypes())
            dispatch(fetchStatus())
            dispatch(fetchOpsEditableMaterials())
            dispatch(fetchApprovals())
        }

        let toDate = new Date()
        toDate.setHours(23, 59, 0, 0)
        toDate = toDate.toISOString()

        let fromDate = new Date()
        fromDate.setDate(fromDate.getDate() - 2)
        fromDate.setHours(0, 0, 0, 0)
        fromDate = fromDate.toISOString()

        const updatedSearchParams = {
            ...searchParams,
            fromDate: fromDate,
            toDate: toDate
        }

        dispatch(updateSearchParams(updatedSearchParams))

        getMaterialIdTeam()
        setIsLoaderVisible(false)
    }, [])

    useEffect(() => {
        if (!isSearchPinned && !isHoveringSearchZone) {
            dispatch(setIsSearchVisible(false))
          }

        const handleMouseMove = (e) => {
            if (isSearchPinned) return

            const panelWidth = window.innerWidth * 0.18
            const buffer = 8
            const screenRightEdge = window.innerWidth
            const activeZoneLeft = screenRightEdge - (panelWidth + buffer)

            if (e.clientX < activeZoneLeft) {
                setIsHoveringSearchZone(false)
                setHasEverHoveredRightEdge(false)
            } else {
                setIsHoveringSearchZone(true)
            }
        }

        if (!isSearchPinned && (isHoveringSearchZone || hasEverHoveredRightEdge)) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
        }
    }, [isSearchPinned, isHoveringSearchZone, hasEverHoveredRightEdge])

    const getMaterialIdTeam = async() => {
        setIsLoaderVisible(true)
        const response = await getMaterialIdTeamData({paginator: false})
        // console.log("materialIdTeamdata-response", response)
        setIsLoaderVisible(false)
        if (response.failure){
            return dispatch(raiseToast({severity:'error', detail: response.data.error , life: 3000}))
        }
        setMaterialIdTeam(response.data)
    }

    useEffect(() => {
        if (materialMasterListData.length) {
            let relatedTempMaterialItems = materialMasterListData.filter(eachMaterial => eachMaterial.materialId.toString().length > 6 && eachMaterial.partialSpecsOnly)
            if (relatedTempMaterialItems.length) {
                let tampMaterialIds = _.uniqBy(_.map(relatedTempMaterialItems, "materialId"))
                getPartialSpecsApprovalInstances(tampMaterialIds)
            }
        }
    }, [materialMasterListData])

    const getPartialSpecsApprovalInstances = async (tempMaterialIds) => {
        setIsLoaderVisible(true)
        const relatedMaterialMasterPartialSpecsApprovals = approvals.filter(eachApproval => pmCompanyConfig.materialMasterPartialSpecsApprovalTypeIds.includes(eachApproval.approvalTypeId))
        const relatedMaterialMasterPartialSpecsApprovalIds = relatedMaterialMasterPartialSpecsApprovals.map(eachApproval => eachApproval.approvalId)

        const approverInstancesRes = await getApprovalInstances({ materialIds: tempMaterialIds, approvalIds: relatedMaterialMasterPartialSpecsApprovalIds, statusIds: [8] })
        console.log("approverInstancesRes", approverInstancesRes)
        setIsLoaderVisible(false)
        if (approverInstancesRes.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "Approval Instance", details: approverInstancesRes.data.error, life: 3000 }))
        } else {
            setApprovalInstances(approverInstancesRes.data.data)
        }
    }

    const getMaterialMasterItemData = async (data) => {
        let materialItemObj = {
            "brandId": data?.brandId?.brandId,
            "categoryId": data?.categoryId?.categoryId,
            "UOMValue": data.UOMValue,
        }

        if (typeof (data.productName) === 'object') {
            materialItemObj["productName"] = data.productName.productName
        } else {
            materialItemObj["productName"] = data.productName
        }

        if (typeof (data.variantName) === 'object') {
            materialItemObj["variantName"] = data.variantName.variantName
        } else {
            materialItemObj["variantName"] = data.variantName
        }

        if (typeof (data.productSpecification) === 'object') {
            materialItemObj["productSpecification"] = data?.productSpecification?.productSpecification
        } else {
            materialItemObj["productSpecification"] = data?.productSpecification
        }

        if (typeof (data.UOM) === 'object') {
            materialItemObj["UOM"] = data.UOM.UOM
        } else {
            materialItemObj["UOM"] = data.UOM
        }
        const materialItemResponse = await getMaterialItem(materialItemObj)
        console.log("getMaterialItem-Response", materialItemResponse)
        if (materialItemResponse.status === 200) {
            setMaterialItemObj(materialItemResponse.data)
        }
    }

    const onSubmitMaterialItemTempData = async (materialItem) => {

        let relatedCategoryMaterialIdTeam = materialIdTeam?.filter(user => user.accessType === "CATEGORY" && user.accessEntity === materialItem.categoryId)

        let specificationAttributesWithValues = []
        materialSpecificationAttributes.map((attribute) => {
            const attributeObj = {
                type: attribute.name,
                value: materialItem[attribute.name] ? materialItem[attribute.name].trim() : null,
                //unit: attribute.unit,
            }
            if (attribute.unit) {
                attributeObj.unit = attribute.unit
            }
            specificationAttributesWithValues.push(JSON.stringify(attributeObj))
        })

        let materialSpecification = []
        if (materialSpecificationAttributes.length > 0) {
            materialSpecificationAttributes.map((attribute) => {
                if (materialItem[attribute.name] && materialItem[attribute.name] != "") {
                    let specificationAttribute = attribute.name + " " + materialItem[attribute.name] + (attribute.unit ? " " + attribute.unit : "")
                    materialSpecification.push(specificationAttribute)
                }
            })
        }
        else {
            materialSpecification.push(materialItem.productSpecification)
        }

        let branchId = 16
        if (rolesList && rolesList?.length > 0) {
            let relatedUserRole = rolesList.find(user => user.userRoleId === activeRoleId)
            if (relatedUserRole) {
                branchId = relatedUserRole.branchId
            }
        }
        
        let data = {
            "brandId": materialItem.brandId,
            "categoryId": materialItem.categoryId,
            "productName": materialItem.productName,
            "variantName": materialItem.variantName,
            "productSpecificationJSON": specificationAttributesWithValues.length > 0 ? specificationAttributesWithValues : null,
            "productSpecification": materialSpecification.join(", "),
            "UOM": materialItem.UOM,
            "UOMValue": materialItem.UOMValue,
            "branchId": branchId,
            "remarks": materialItem.remarks,
            "statusId": 1,
            "keywords": materialItem.keywords,
            "materialIdType": materialItem.materialIdType,
            "materialImages": materialItem.materialImages,
            "partialSpecsOnly": materialItem.partialSpecsOnly,
            "createdBy": userId,
            "updatedBy": userId,
        }

        let assigneeCentralUserName = ""
        if (relatedCategoryMaterialIdTeam.length > 0) {
            const randomNumber = Math.floor(Math.random() * (relatedCategoryMaterialIdTeam.length - 1))
            data.assigneeCentralUserId = relatedCategoryMaterialIdTeam[randomNumber]?.userId

            let relatedUser = pmCompanyUsers.find(eachUser => eachUser.userId === data.assigneeCentralUserId)
            if (relatedUser) {
                assigneeCentralUserName = getFullName(relatedUser.firstName, relatedUser.lastName)
            }
        } else {
            data.assigneeCentralUserId = 144
        }

        let confirmMessage = "Do you want to request material item..?"

        if (assigneeCentralUserName) {
            confirmMessage = `This request has been assigned to ${assigneeCentralUserName}.\n` + confirmMessage
        }

        // this request has been assigned to "ABC"
        if (window.confirm(confirmMessage)) {
            setIsLoaderVisible(true)
            const addMaterialItemTempResponse = await addMaterialMasterTempData(data)
            console.log("addMaterialItemTemp-Response", addMaterialItemTempResponse)
            if (addMaterialItemTempResponse.status === 200) {
                const data = addMaterialItemTempResponse.data
                const message = data?.message
                if (data?.success) {
                    setMaterialItemTempObj({ ...materialItemInitialState })
                    setMaterialSpecificationAttributes([])
                    setMaterialVariantProducts([])
                    setMaterialSpecification([])
                    setVisibleMaterialItemRequest(false)
                    setMaterialImages([])
                    dispatch(raiseToast({
                        severity: 'success',
                        detail: (
                            <span>
                                Requested material item successfully with id {addMaterialItemTempResponse?.data?.data?.materialId}
                                <CopyToClipboard text={addMaterialItemTempResponse?.data?.data?.materialId} />
                            </span>
                        ),
                        life: 3000
                    }))
                }
                else {
                    dispatch(raiseToast({ severity: 'error', detail: message, life: 3000 }))
                }
            } else {
                dispatch(raiseToast({ severity: 'error', detail: addMaterialItemTempResponse.data.error, life: 3000 }))
            }
            setIsLoaderVisible(false)
        }
    }

    const onSubmitMaterialItemInterimData = async (materialItem, materialItemTempData, buyerReqAndPOMaterialIds) => {
        let specificationAttributesWithValues = []
        materialSpecificationAttributes.map((attribute) => {
            const attributeObj = {
                type: attribute.name,
                value: materialItem[attribute.name] ? materialItem[attribute.name].trim() : null,
                //unit: attribute.unit,
            }
            if (attribute.unit) {
                attributeObj.unit = attribute.unit
            }
            specificationAttributesWithValues.push(JSON.stringify(attributeObj))
        })

        let materialSpecification = []
        if (materialSpecificationAttributes.length > 0) {
            materialSpecificationAttributes.map((attribute) => {
                if (materialItem[attribute.name] && materialItem[attribute.name] != "") {
                    let specificationAttribute = attribute.name + " " + materialItem[attribute.name] + (attribute.unit ? " " + attribute.unit : "")
                    materialSpecification.push(specificationAttribute)
                }
            })
        }
        else {
            materialSpecification.push(materialItem.productSpecification)
        }

        if (materialSpecification.length > 0) {
            if (materialSpecification.join(", ")?.length < 3) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Specification should be more than 3 characters", life: 3000 }))
            }
        }

        let data = {
            "materialId": materialItemTempData.materialId,
            "brandId": materialItem.brandId,
            "categoryId": materialItem.categoryId,
            "productName": materialItem.productName,
            "variantName": materialItem.variantName,
            "productSpecificationJSON": specificationAttributesWithValues.length > 0 ? specificationAttributesWithValues : null,
            "productSpecification": materialSpecification.join(", "),
            "UOM": materialItem.UOM,
            "UOMValue": materialItem.UOMValue,
            "branchId": materialItem.branchId,
            "remarks": materialItem.remarks,
            "keywords": materialItem.keywords,
            "materialImages": materialItem.materialImages,
            "partialSpecsOnly": materialItem.partialSpecsOnly,
            "isRouted": materialItemTempData.remarks && materialItemTempData?.remarks?.toLowerCase().includes('routed') ? true : null,
            "buyerReqAndPOMaterialIds": buyerReqAndPOMaterialIds,
            "thumbnailImageId": materialItem.thumbnailImageId,
            "productDescription": materialItem.productDescription
        }

        if (isCategoryUser) {
            data.isCategoryUser = isCategoryUser
        }

        let confirmMessage = "Do you want to approve material item..?"
        if (materialItem.partialSpecsOnly && materialItemTempData.statusId === 1) {
            confirmMessage = `You selected Partial Specs Only. This material item needs approval from satyam singh, Once he approved you can use that material.\nDo you want to continue..?`
        }

        if (window.confirm(confirmMessage)) {
            setIsLoaderVisible(true)
            let addMaterialItemInterimResponse
            if (materialItem.partialSpecsOnly && materialItemTempData.statusId === 1) {
                data.statusId = 7
                addMaterialItemInterimResponse = await updatedMaterialMasterTemp(data)
            } else {
                addMaterialItemInterimResponse = await addMaterialMasterInterimData(data)

            }
            console.log("addMaterialItemInterim-response", addMaterialItemInterimResponse)
            if (addMaterialItemInterimResponse.failure) {
                setIsLoaderVisible(false)
                dispatch(raiseToast({ severity: 'error', detail: addMaterialItemInterimResponse.data.error, life: 3000 }))
            } else {
                setIsLoaderVisible(false)
                setMaterialItemInterimObj({ ...materialItemInitialState })
                setMaterialSpecificationAttributes([])
                setMaterialVariantProducts([])
                setMaterialSpecification([])
                setMaterialItemObj({})
                setVisibleEditPendingMaterialItem(false)
                dispatch(approvedMaterialItem(materialItemTempData.materialId))

                if (materialItem.partialSpecsOnly && materialItemTempData.statusId === 1) {
                    dispatch(raiseToast({ severity: 'success', detail: `Request sent successfully`, life: 3000 }))
                } else {
                    dispatch(raiseToast({
                        severity: 'success',
                        detail: (
                            <span>
                                Material item approved successfully with {addMaterialItemInterimResponse?.data?.assignedMaterialId}
                                <CopyToClipboard text={addMaterialItemInterimResponse?.data?.assignedMaterialId} />
                            </span>
                        ),
                        life: 3000
                    }))
                }
            }
        }
    }

    const updateMaterialItem = async (materialItem, updatedMaterialItem) => {
        let specificationAttributesWithValues = []
        materialSpecificationAttributes.map((attribute) => {
            const attributeObj = {
                type: attribute.name,
                value: materialItem[attribute.name] ? materialItem[attribute.name] : null,
            }
            if (attribute.unit) {
                attributeObj.unit = attribute.unit
            }
            specificationAttributesWithValues.push(JSON.stringify(attributeObj))
        })

        let materialSpecification = []
        if (materialSpecificationAttributes.length > 0) {
            materialSpecificationAttributes.map((attribute) => {
                if (materialItem[attribute.name] && materialItem[attribute.name] != "") {
                    let specificationAttribute = attribute.name + " " + materialItem[attribute.name] + (attribute.unit ? " " + attribute.unit : "")
                    materialSpecification.push(specificationAttribute)
                }
            })
        }
        else {
            materialSpecification.push(materialItem.productSpecification)
        }

        if (materialSpecification.length > 0) {
            if (materialSpecification.join(", ")?.length < 3) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Specification should be more than 3 characters", life: 3000 }))
            }
        }

        let data = {
            "materialId": updatedMaterialItem.materialId,
            "brandId": materialItem.brandId,
            "categoryId": materialItem.categoryId,
            "productName": materialItem.productName,
            "variantName": materialItem.variantName,
            "productSpecificationJSON": specificationAttributesWithValues.length > 0 ? specificationAttributesWithValues : null,
            "productSpecification": materialSpecification.join(", "),
            "UOM": materialItem.UOM,
            "UOMValue": materialItem.UOMValue,
            "branchId": materialItem.branchId,
            "remarks": materialItem.remarks ? materialItem.remarks : null,
            "keywords": materialItem.keywords,
            "materialImages": materialItem.materialImages,
            "thumbnailImageId": materialItem.thumbnailImageId,
            "productDescription": materialItem.productDescription
        }

        if (isCategoryUser) {
            data.isCategoryUser = isCategoryUser
        }

        if(updatedMaterialItem.vmiMaterialId){
            data.vmiMaterialId = updatedMaterialItem.vmiMaterialId
        }

        let confirmMessage = "Do you want to update material item..?"

        if (vmiContractItems.length) {
            let vmiMaterialId = updatedMaterialItem.materialId.toString()
            let relatedVMIMaterialIds = null
            if (vmiMaterialId.startsWith("7")) {
                relatedVMIMaterialIds = _.uniqBy(_.map(vmiContractItems, "permMaterialId"))
            } else {
                relatedVMIMaterialIds = _.uniqBy(_.map(vmiContractItems, "materialId"))
            }

            confirmMessage = <p style={{color: "red"}}>{`Updating this material ${updatedMaterialItem.materialId} will update all linked material Ids (${relatedVMIMaterialIds.join(", ")}).\nAre you sure you want to update all materials`}</p>

            data.vmiContractItemsMaterialIds = relatedVMIMaterialIds
        }
        data.confirmMessage = confirmMessage
        setConfirmUpdateMaterialItemObj(data)
        setIsConfirmUpdateMaterialDialogVisible(true)

        // if (window.confirm(confirmMessage)) {
        //     setIsLoaderVisible(true)
        //     const updateMaterialItemResponse = await updateMaterialMasterByMaterialId(data)
        //     console.log("updateMaterialItem-Response", updateMaterialItemResponse)
        //     if (updateMaterialItemResponse.failure) {
        //         setIsLoaderVisible(false)
        //         dispatch(raiseToast({ severity: 'error', summary: updateMaterialItemResponse.data.error, life: 3000 }))
        //     } else {

        //         const updatedEditedMaterialItem = materialMasterListData.map((eachMaterialItem) => {
        //             if (eachMaterialItem.materialId === updateMaterialItemResponse?.data?.materialId) {
        //                 return {
        //                     ...eachMaterialItem,
        //                     ...updateMaterialItemResponse.data
        //                 }
        //             } else {
        //                 return { ...eachMaterialItem }
        //             }
        //         })

        //         dispatch(updateMaterialItemData(updatedEditedMaterialItem))
        //         dispatch(raiseToast({ severity: 'success', detail: "Updated rate contract product successfully", life: 3000 }))
        //         setIsLoaderVisible(false)
        //         setVisibleEditMaterialItem(false)
        //         setEditedMaterialItemObj({})
        //         setMaterialSpecificationAttributes([])
        //         setMaterialVariantProducts([])
        //         setMaterialSpecification([])
        //         setMaterialItemObj({})
        //         dispatch(approvedMaterialItem(updatedMaterialItem.materialId))
        //         dispatch(raiseToast({ severity: 'success', detail: `Material item updated successfully with ${updateMaterialItemResponse?.data?.materialId}`, life: 3000 }))
        //     }
        // }
    }

    const handleConfirmUpdateMaterialItems = async() => {
        setIsLoaderVisible(true)
        const updateMaterialItemResponse = await updateMaterialMasterByMaterialId(confirmUpdateMaterialItemObj)
        console.log("updateMaterialItem-Response", updateMaterialItemResponse)
        if (updateMaterialItemResponse.failure) {
            setIsLoaderVisible(false)
            dispatch(raiseToast({ severity: 'error', summary: updateMaterialItemResponse.data.error, life: 3000 }))
        } else {

            const updatedEditedMaterialItem = materialMasterListData.map((eachMaterialItem) => {
                if (eachMaterialItem.materialId === updateMaterialItemResponse?.data?.materialId) {
                    return {
                        ...eachMaterialItem,
                        ...updateMaterialItemResponse.data
                    }
                } else {
                    return { ...eachMaterialItem }
                }
            })

            dispatch(updateMaterialItemData(updatedEditedMaterialItem))
            dispatch(raiseToast({ severity: 'success', detail: "Updated rate contract product successfully", life: 3000 }))
            setIsLoaderVisible(false)
            setVisibleEditMaterialItem(false)
            setEditedMaterialItemObj({})
            setMaterialSpecificationAttributes([])
            setMaterialVariantProducts([])
            setMaterialSpecification([])
            setMaterialItemObj({})
            setIsConfirmUpdateMaterialDialogVisible(false)
            setConfirmUpdateMaterialItemObj({})
            setVMIContractItems([])
            dispatch(approvedMaterialItem(confirmUpdateMaterialItemObj.materialId))
            dispatch(raiseToast({ severity: 'success', detail: `Material item updated successfully with ${updateMaterialItemResponse?.data?.materialId}`, life: 3000 }))
        }
    }

    const handleCloseConfirmUpdateMaterialDialog = () => {
        setIsConfirmUpdateMaterialDialogVisible(false)
        setConfirmUpdateMaterialItemObj({})
    }

    const handleOnClickFilter = () => {
        setIsFilterShown(current => !current);
    }

    const handleOnClickSearchButton = (materialMasterTempSearchInputs) => {
        if (materialMasterTempSearchInputs.searchBy !== "all") {
            let searchText = ''
            if (materialMasterTempSearchInputs.searchText) {
                searchText = materialMasterTempSearchInputs.searchText.trim()
            }

            if (!searchText && searchText === "") {
                return Toast.current.show({ severity: 'warn', detail: "Please enter search text", life: 3000 })
            }
        } else {
            //materialMasterTempSearchInputs.assigneeCentralUserIds = [userId]
        }

        dispatch(fetchMaterialProductRequestData({ ...paginationParams, ...materialMasterTempSearchInputs }))
    }

    const actionMenuItems = [
        {
            label: 'Request Material Item',
            icon: '',
            command: () => {
                setVisibleMaterialItemRequest(true)
            },
            permissions: [33]
        },
        {
            label: 'Pending Material Items',
            icon: '',
            command: () => {
                setVisiblePendingMaterialItems(true)
            },
            permissions: [34]
        },
    ]

    const handlePageChange = async (e) => {
        let materialMasterListParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
        }
        if (materialMasterSearchParams.searchBy !== "all") {
            materialMasterListParams[materialMasterSearchParams.searchBy] = materialMasterSearchParams.searchText?.trim()
        }

        dispatch(fetchMaterialMasterListData({ ...materialMasterSearchParams, ...materialMasterListParams }))
    }

    const getCategoryBody = (row) => {
        const relatedMaterialCategory = materialCategory.find(eachCategory => eachCategory.categoryId === row.categoryId)
        if (relatedMaterialCategory?.categoryName) {
            return relatedMaterialCategory.categoryName
        } else {
            return ""
        }
    }

    const getBrandBody = (row) => {
        const relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandId === row.brandId)
        if (relatedMaterialBrand?.brandName) {
            return relatedMaterialBrand.brandName
        } else {
            return ""
        }
    }

    const getCreatedByBody = (row) => {
        if (row['createdBy.firstName'] && row['createdBy.lastName']) {
            return `${row['createdBy.firstName']} ${row['createdBy.lastName']}`
        } if (row['createdBy.firstName']) {
            return row['createdBy.firstName']
        } else {
            return row['createdBy.lastName']
        }
    }

    const getCreatedAtBody = (row) => {
        return (
            moment(row.createdAt).format(DATE_FORMAT)
        )
    }

    const sortProductNamesInAlphabeticalOrder = (arr, fieldName) => {
        let sortedArr = arr.slice().sort((materialItemA, materialItemB) => {

            const hasMaterialSpecA = 'materialSpecificationId' in materialItemA
            const hasMaterialSpecB = 'materialSpecificationId' in materialItemB

            if (hasMaterialSpecA && !hasMaterialSpecB) {
                return -1
            }
            if (!hasMaterialSpecA && hasMaterialSpecB) {
                return 1
            }

            const fieldNameA = materialItemA[fieldName]?.toLowerCase() || ''
            const fieldNameB = materialItemB[fieldName]?.toLowerCase() || ''
            if (fieldNameA < fieldNameB) {
                return -1
            }
            if (fieldNameA > fieldNameB) {
                return 1
            }
            return 0
        })
        return sortedArr
    }

    const getMaterialProductsByCategory = async (params) => {
        const response = await getMaterialProductsByCategoryId(params)
        if (response.failure){
            return dispatch(raiseToast({severity:'error', detail: response.data.error , life: 3000}))
        }
        const combinedResults = response.data.materialMasterResponse.concat(response.data.materialSpecificationsResponse);

        // const sortedMaterialProducts = sortArrayOfObjectsInAlphabeticalOrder(combinedResults, 'productName')
        const sortedMaterialProducts = sortProductNamesInAlphabeticalOrder(combinedResults, 'productName')
        dispatch(updateMaterialProductsByCaterogy(sortedMaterialProducts))
        return sortedMaterialProducts
    }

    const getMaterialProdUOMsByCategory = async (params) => {
        const response = await getMaterialProductsUOMsByCategoryId(params)
        dispatch(updateMaterialProductsUOMsByCaterogy(response.data))
        return response.data
    }

    const getVMIContractsItemsByVMIMaterialId = async(vmiMaterialId) => {
        setIsLoaderVisible(true)
        const vmiContractsItemsRes = await getVMIContractsItemsByMaterialId(vmiMaterialId)
        console.log("vmiContractsItemsRes", vmiContractsItemsRes)
        setIsLoaderVisible(false)
        if (vmiContractsItemsRes.failure){
            return dispatch(raiseToast({severity:'error', detail: vmiContractsItemsRes.data.error , life: 3000}))
        }

        if(vmiContractsItemsRes.data && vmiContractsItemsRes.data.length){
            // setVMIContractItems([...vmiContractsItemsRes.data])
            return vmiContractsItemsRes.data[0]
        }

        return null
    }

    const getVMIContractsItemsByVMIPermMaterialId = async(vmiMaterialId) => {
        setIsLoaderVisible(true)
        const vmiContractsItemsRes = await getVMIContractsItemsByPermMaterialId(vmiMaterialId)
        setIsLoaderVisible(false)
        if (vmiContractsItemsRes.failure){
            return dispatch(raiseToast({severity:'error', detail: vmiContractsItemsRes.data.error , life: 3000}))
        }

        if(vmiContractsItemsRes.data && vmiContractsItemsRes.data.length){
            setVMIContractItems([...vmiContractsItemsRes.data])
        }
    }

    const constructEditMaterialItem = async (row) => {
        setIsLoaderVisible(true)
        let materialProductsByCaterogy = await getMaterialProductsByCategory(row.categoryId)
        let materialProductsUOMsByCaterogy = await getMaterialProdUOMsByCategory(row.categoryId)
        
        let vmiMaterialId = row.materialId.toString() 
        if (vmiMaterialId.startsWith("7")) {
            await getVMIContractsItemsByVMIMaterialId(vmiMaterialId)
        }else{
            await getVMIContractsItemsByVMIPermMaterialId(row.materialId)
        }

        let selectedMaterialItem = { ...row }
        if (selectedMaterialItem.productSpecificationJSON) {
            if (typeof selectedMaterialItem.productSpecificationJSON === "string") {
                selectedMaterialItem.productSpecificationJSON = JSON.parse(selectedMaterialItem.productSpecificationJSON)
            }else{
                selectedMaterialItem.productSpecificationJSON = selectedMaterialItem.productSpecificationJSON.map(jsonString => JSON.parse(jsonString))
            }
        }

        if (materialProductsByCaterogy.length > 0) {
            let relatedMaterialSpecificationSOPs = materialProductsByCaterogy.filter(specification => {
                if (specification.materialSpecificationId) {
                    if (specification.categoryId === row.categoryId && specification.productName.toLowerCase() === row.productName.toLowerCase() && specification.variantName.toLowerCase() === row.variantName?.toLowerCase()) {
                        return true
                    }
                }
            })

            let sortedMaterialSpecificationSOPs = sortArrayOfObjectsInAlphabeticalOrder(relatedMaterialSpecificationSOPs, "attribute")

            if (sortedMaterialSpecificationSOPs.length > 0) {
                let specificationAttributes = []
                sortedMaterialSpecificationSOPs.map(specification => {
                    let attributeObj = {
                        name: specification.attribute,
                        mandatory: specification.materialSpecificationMandatoryTypeId,
                        unit: specification.attributeUnit
                    }
                    specificationAttributes.push(attributeObj)

                    let relatedSpecificationAttribute = selectedMaterialItem.productSpecificationJSON?.find(eachSpecification => eachSpecification.type?.toLowerCase() === specification.attribute?.toLowerCase())
                    if (relatedSpecificationAttribute) {
                        selectedMaterialItem[specification.attribute] = relatedSpecificationAttribute.value
                    }
                })
                setMaterialSpecificationAttributes(specificationAttributes)
                setMaterialSpecification([...sortedMaterialSpecificationSOPs])
            }
            else {
                setMaterialSpecificationAttributes([])
                // setMaterialSpecification([...relatedSpecifications])
            }
        }

        let relatedCategory = materialCategory?.find(category => category.categoryId === row.categoryId)
        let relatedBrand = materialBrands?.find(brand => brand.brandId === row.brandId)
        let relatedUom = materialUOMData?.find(uom => uom.UOM === row.UOM)
        setEditedMaterialItemObj({ ...selectedMaterialItem, currentProdSpecification: selectedMaterialItem.productSpecification, categoryId: relatedCategory, brandId: relatedBrand, UOM: relatedUom })
        setVisibleEditMaterialItem(true)
        setIsLoaderVisible(false)
    }

    const onClickEditMaterialItem = async (row) => {
        let permMaterialItem = { ...row }
        let vmiMaterialId = row.materialId.toString()
        if (vmiMaterialId.startsWith("7")) {
            let vmiContractItem = await getVMIContractsItemsByVMIMaterialId(vmiMaterialId)

            setIsLoaderVisible(true)
            let getMaterialItemResponse = await getMaterialItemByMaterialId(vmiContractItem.permMaterialId)
            setIsLoaderVisible(false)
            if (getMaterialItemResponse.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: getMaterialItemResponse.data.error, life: 3000 }))
            }

            if (getMaterialItemResponse.data) {
                permMaterialItem = { ...getMaterialItemResponse.data, vmiMaterialId: vmiContractItem.materialId }
            }
        }

        constructEditMaterialItem(permMaterialItem)
    }

    const materialIdBody = (row) => {
        const relatedStatus = statusList.find((status) => status.statusId == row.statusId)?.status

        let rejectedMaterialApprovalInstance = null
        let rejectedUserName = null
        if (row.materialId.toString().length > 6 && row.partialSpecsOnly) {
            let relatedRejectApprovalInstances = approvalInstances.filter(eachApprovalInstances => eachApprovalInstances.materialId === row.materialId)
            if (relatedRejectApprovalInstances.length) {
                if (relatedRejectApprovalInstances.length === 1) {
                    rejectedMaterialApprovalInstance = relatedRejectApprovalInstances[0]
                } else {
                    let sortedApprovalInstances = sortArrayOfObjectsInAscendingDateOrder(relatedRejectApprovalInstances)
                    rejectedMaterialApprovalInstance = sortedApprovalInstances[0]
                }

                let relatedUser = pmCompanyUsers.find(eachUser => eachUser.userId === rejectedMaterialApprovalInstance.processedBy)
                if (relatedUser) {
                    rejectedUserName = getFullName(relatedUser.firstName, relatedUser.lastName)
                }
            }
        }

        return (
            <>
                {
                    row.partialSpecsOnly && ([9, 7].includes(row.statusId) || rejectedMaterialApprovalInstance) ?
                        <Tooltip target={`.custom-tool-tip-material-item-status${row.materialId}`} position="top" autoHide >
                            {[9, 7].includes(row.statusId) && <p className='m-0'><b>Status:</b>  {relatedStatus} </p>}
                            {
                                rejectedMaterialApprovalInstance &&
                                `Partial Specs rejected by ${rejectedUserName}, with remarks: ${rejectedMaterialApprovalInstance.processedRemarks}`
                            }
                        </Tooltip>
                        : null
                }
                <a className={row.partialSpecsOnly && ([9, 7].includes(row.statusId) || rejectedMaterialApprovalInstance) ? `custom-tool-tip-material-item-status${row.materialId}` : ''} onClick={() => onClickEditMaterialItem(row)} style={{ cursor: "pointer", textDecoration: "underline" }}>{row.materialId}</a>
                {row.partialSpecsOnly && ([9, 7].includes(row.statusId) || rejectedMaterialApprovalInstance) ? "*" : null}
            </>
        )
    }

    const getProductSpecification = (row) =>{
        return(
            <Description text={row.productSpecification} maxLength={100} />
        )
    }

    const tableColumns = [
        { 
            header: 'Material Id',
            field: 'materialId',
            style: { minWidth: '120px' },
            body: materialIdBody
        },
        {
            header: 'Category',
            field: '',
            body: getCategoryBody,
            style: { minWidth: "130px" }
        },
        {
            header: 'Brand',
            field: '',
            body: getBrandBody
        },
        {
            header: 'Product Name',
            field: 'productName',
            style: { minWidth: "200px" }
        },
        {
            header: 'Variant Name',
            field: 'variantName',
            style: { minWidth: "150px" }
        },
        {
            header: 'Product Specification',
            field: 'productSpecification',
            body: getProductSpecification,
            style: { minWidth: "250px" }
        },
        {
            header: 'UOM',
            field: 'UOM'
        },
        {
            header: 'Created By',
            field: '',
            body: getCreatedByBody,
            style: { minWidth: "180px" }
        },
        {
            header: 'Created At',
            field: '',
            body: getCreatedAtBody,
            style: { minWidth: "110px" }
        },
    ]

    const handleVisibleEditMaterialItem = () => {
        setVisibleEditMaterialItem(false)
        setEditedMaterialItemObj({})
        setMaterialSpecification([])
        setMaterialSpecificationAttributes([])
        setMaterialItemObj({})
        setVMIContractItems([])
    }

    const handleSearchTabDisplay = () => {
        if (!isSearchPinned) {
          dispatch(setIsSearchVisible(!isSearchVisible))
        }
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
        {
            icon: isSearchPinned ? "pi pi-lock" : "pi pi-lock-open",
            command: () => toggleSearchPin() 
        }
    ]

    let displaySearchBox = isSearchPinned || isHoveringSearchZone || isSearchVisible

    const actionButtonsForPendingMaterial = [
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleOnClickFilter,
            // className: isSearchActive ? "active-group-button" : ""
        },
    ]
    
    return (
        <div className=''>
            <Toast ref={Toast} />
            <div
                onMouseEnter={() => {
                    if (!isSearchPinned) {
                        setIsHoveringSearchZone(true)
                        setHasEverHoveredRightEdge(true)
                        dispatch(setIsSearchVisible(true))
                    }
                }}
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '8px',
                    height: '100vh',
                    zIndex: 999
                }}
            />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">MATERIAL MASTER</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className="material-item-request">
                <Dialog header="Material Item Request" className="material-item-request" visible={visibleMaterialItemRequest} style={{ width: '70vw', minHeight: "60%" }} onHide={() => setVisibleMaterialItemRequest(false)} >
                    <MaterialItemRequest
                        materialItemTempObj={materialItemTempObj}
                        materialCategory={materialCategory}
                        materialIdTypes={materialIdTypes}
                        materialBrands={materialBrands}
                        materialUOMData={materialUOMData}
                        materialProductsByCaterogy={materialProductsByCaterogy}
                        setMaterialItemTempObj={setMaterialItemTempObj}
                        onSubmitMaterialItemTempData={onSubmitMaterialItemTempData}
                        materialVariantProducts={materialVariantProducts}
                        setMaterialVariantProducts={setMaterialVariantProducts}
                        materialSpecification={materialSpecification}
                        setMaterialSpecification={setMaterialSpecification}
                        materialProductsUOMsByCaterogy={materialProductsUOMsByCaterogy}
                        materialSpecificationMandatoryTypes={materialSpecificationMandatoryTypes}
                        materialIdTeam={materialIdTeam}
                        materialSpecificationAttributes={materialSpecificationAttributes}
                        setMaterialSpecificationAttributes={setMaterialSpecificationAttributes}
                        materialImages={materialImages}
                        setMaterialImages={setMaterialImages}
                    />
                </Dialog>
            </div>
            <Dialog header="Pending Material Items" visible={visiblePendingMaterialItems} style={{ width: '90vw', minHeight: "60%" }} onHide={() => setVisiblePendingMaterialItems(false)} >
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button icon="pi pi-filter" label="Filter" className="h-2rem  p-2 action-btn hover:surface-300 hover:text-700" onClick={handleOnClickFilter} /> */}
                    <ButtonGroup buttons={actionButtonsForPendingMaterial} />
                </div>
                <div className='flex flex-row'>
                    <div className="p-card" style={{ order: "1", width: isFilterShown && !isMobileDevice ? "80%" : "100%" }}>
                        <PendingMaterialItems
                            materialCategory={materialCategory}
                            materialIdTypes={materialIdTypes}
                            materialBrands={materialBrands}
                            materialUOMData={materialUOMData}
                            materialProductsByCaterogy={materialProductsByCaterogy}
                            materialItemInterimObj={materialItemInterimObj}
                            setMaterialItemInterimObj={setMaterialItemInterimObj}
                            onSubmitMaterialItemInterimData={onSubmitMaterialItemInterimData}
                            materialVariantProducts={materialVariantProducts}
                            setMaterialVariantProducts={setMaterialVariantProducts}
                            materialSpecification={materialSpecification}
                            setMaterialSpecification={setMaterialSpecification}
                            materialProductsUOMsByCaterogy={materialProductsUOMsByCaterogy}
                            materialSpecificationMandatoryTypes={materialSpecificationMandatoryTypes}
                            materialIdTeam={materialIdTeam}
                            materialSpecificationAttributes={materialSpecificationAttributes}
                            setMaterialSpecificationAttributes={setMaterialSpecificationAttributes}
                            materialMasterInterimData={materialMasterInterimData}
                            //getMaterialInterimData={getMaterialInterimData}
                            materialItemObj={materialItemObj}
                            setMaterialItemObj={setMaterialItemObj}
                            getMaterialMasterItemData={getMaterialMasterItemData}
                            isCategoryUser={isCategoryUser}
                            visibleEditPendingMaterialItem={visibleEditPendingMaterialItem}
                            setVisibleEditPendingMaterialItem={setVisibleEditPendingMaterialItem}
                            materialMasterTempSearchInputs={materialMasterTempSearchInputs}
                        />
                    </div>
                    {isFilterShown && !isMobileDevice &&
                        <div style={{ order: "2", width: "20%", paddingLeft: "10px" }} className="justify-content-end ">
                            <MaterialPendingRequestSearchBar
                                handleOnClickSearchButton={handleOnClickSearchButton}
                                materialMasterTempSearchInputs={materialMasterTempSearchInputs}
                                setMaterialMasterTempSearchInputs={setMaterialMasterTempSearchInputs}
                            />
                        </div>
                    }
                    {
                        isFilterShown && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Sidebar position='right' visible={isFilterShown} onHide={() => setIsFilterShown(false)}>
                                <MaterialPendingRequestSearchBar
                                    handleOnClickSearchButton={handleOnClickSearchButton}
                                    materialMasterTempSearchInputs={materialMasterTempSearchInputs}
                                    setMaterialMasterTempSearchInputs={setMaterialMasterTempSearchInputs}
                                />
                            </Sidebar>
                        </div>
                    }
                </div>
            </Dialog>
            <Dialog header="Edit Material Item" visible={visibleEditMaterialItem} style={{ width: '75vw', minHeight: "60%" }} onHide={() => handleVisibleEditMaterialItem()} >
                <EditMaterialItem
                    editedMaterialItemObj={editedMaterialItemObj}
                    setEditedMaterialItemObj={setEditedMaterialItemObj}
                    materialCategory={materialCategory}
                    materialIdTypes={materialIdTypes}
                    materialBrands={materialBrands}
                    materialUOMData={materialUOMData}
                    materialProductsByCaterogy={materialProductsByCaterogy}
                    materialVariantProducts={materialVariantProducts}
                    setMaterialVariantProducts={setMaterialVariantProducts}
                    materialSpecification={materialSpecification}
                    setMaterialSpecification={setMaterialSpecification}
                    materialProductsUOMsByCaterogy={materialProductsUOMsByCaterogy}
                    materialSpecificationMandatoryTypes={materialSpecificationMandatoryTypes}
                    materialIdTeam={materialIdTeam}
                    materialSpecificationAttributes={materialSpecificationAttributes}
                    setMaterialSpecificationAttributes={setMaterialSpecificationAttributes}
                    materialMasterInterimData={materialMasterInterimData}
                    getMaterialMasterItemData={getMaterialMasterItemData}
                    isCategoryUser={isCategoryUser}
                    materialItemObj={materialItemObj}
                    setMaterialItemObj={setMaterialItemObj}
                    updateMaterialItem={updateMaterialItem}
                    vmiContractItems={vmiContractItems}
                />
            </Dialog>
            <Loading visible={isLoaderVisible} />
            <div className='flex flex-row'>
                <div className="material-master-table" style={{ order: "1", width: displaySearchBox && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={materialMasterListPaginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={materialMasterListPaginationParams.totalRecords}
                                tableColumns={tableColumns}
                                rows={materialMasterListPaginationParams.recordsPerPage}
                                data={materialMasterListData}
                                scrollable={"true"}
                                paginator
                                loading={isPageLoading}
                                excessPagesFound={materialMasterListPaginationParams.excessPagesFound}
                                scrollHeight="550px"
                            />
                        </div>
                    </div>
                </div>
                {displaySearchBox && !isMobileDevice && (
                    <div
                        style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end"
                        onMouseLeave={(e) => {
                            const bounds = e.currentTarget.getBoundingClientRect()
                            const leftExit = e.clientX < bounds.left
                            const topExit = e.clientY < bounds.top
                            const bottomExit = e.clientY > bounds.bottom

                            if (!isSearchPinned && (leftExit || topExit || bottomExit)) {
                                setIsHoveringSearchZone(false)
                                setHasEverHoveredRightEdge(false)
                            }
                        }}

                        onMouseEnter={() => {
                            if (!isSearchPinned) {
                                setIsHoveringSearchZone(true)
                            }
                        }}
                    >
                         <Search />
                    </div>
                )}

                {
                    isSearchVisible && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <Search />
                        </Sidebar>
                    </div>
                }
            </div>
            <ConfirmDialog
                visible={isConfirmUpdateMaterialDialogVisible}
                onHide={() => handleCloseConfirmUpdateMaterialDialog()}
                message={confirmUpdateMaterialItemObj.confirmMessage}
                header="Confirmation"
                icon="pi pi-exclamation-triangle"
                footer={
                    <div>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            onClick={() => handleCloseConfirmUpdateMaterialDialog()}
                            className="p-button-text"
                            applyThrottle={true}
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            onClick={() => handleConfirmUpdateMaterialItems()}
                            autoFocus
                            applyThrottle={true}
                        />
                    </div>
                }
            />
        </div>
    )
}

export default MaterialMaster
